import { Field, Label, Switch, SwitchProps } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

interface FormSwitchProps extends SwitchProps {
  label?: string;
  className?: string;
  wrapperClassName?: string;
  labelClassName?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function FormSwitch({
  label,
  className,
  wrapperClassName,
  labelClassName,
  size = 'md',
  ...otherProps
}: FormSwitchProps) {
  const sizeClasses = {
    sm: 'h-4 w-7',
    md: 'h-6 w-11',
    lg: 'h-8 w-14',
  };
  return (
    <Field
      className={twMerge([
        'flex w-full items-center justify-start gap-2',
        wrapperClassName,
      ])}
    >
      {label && (
        <Label
          as="span"
          passive
          className={twMerge([
            'text-sm font-medium leading-6 text-gray-900',
            size === 'sm' && 'text-xs',
            size === 'md' && 'text-sm',
            size === 'lg' && 'text-base',
            labelClassName,
          ])}
        >
          {label}
        </Label>
      )}
      <Switch
        className={twMerge([
          'group relative inline-flex flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600',
          className,
          sizeClasses[size],
        ])}
        {...otherProps}
      >
        <span
          aria-hidden="true"
          className={twMerge([
            'pointer-events-none inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
            size === 'sm' && 'h-3 w-3 group-data-[checked]:translate-x-3',
            size === 'md' && 'h-5 w-5 group-data-[checked]:translate-x-5',
            size === 'lg' && 'h-7 w-7 group-data-[checked]:translate-x-6',
          ])}
        />
      </Switch>
    </Field>
  );
}
